// extracted by mini-css-extract-plugin
module.exports = {"card-container":"companiesList_card-container__17rwH","fill":"companiesList_fill__1OLfC","competitors-container":"companiesList_competitors-container__PIpdp"};